export { default as PaperClipSolidIcon } from './PaperClipSolidIcon';
